import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {Button, Icon} from '@goguardian/based';
import _ from 'lodash';

import style from './style.scss';

class Finish extends React.Component {

  adminClick() {
    window.location = 'https://admin.goguardian.com';
  }

  teacherClick() {
    window.location = 'https://teacher.goguardian.com';
  }

  fleetClick() {
    window.location = 'https://fleet.goguardian.com';
  }

  directorClick() {
    window.location = 'https://director.goguardian.com';
  }

  render() {
    const isDirectorOnly = this.props.products.length === 1 && this.props.products[0] === 4;
    return (
      <div className={style.step}>
        <div className={style.stepHeader}>
          <Link to="/getting-started/finish"><Icon value="arrow-left"/></Link>

          <h1>Congratulations</h1>
          {isDirectorOnly && <h2>Your GoGuardian product is active.</h2>}
          {!isDirectorOnly && <h2>Your GoGuardian trial has begun.</h2>}

          <p>From here, you can manage your products, or go straight to your Dashboard to start using GoGuardian.</p>
        </div>

        {_.indexOf(this.props.products, 1) !== -1 && <div className={style.gg4a}>
          <h2>GoGuardian Admin</h2>
          <Button onClick={this.adminClick} block>
            Take me to my Admin Dashboard
          </Button>
        </div>}

        {_.indexOf(this.props.products, 2) !== -1 && <div className={style.group}>
          <h2>GoGuardian Teacher</h2>
          <Button onClick={this.teacherClick} block>
            Take me to my Teacher Dashboard
          </Button>
        </div>}

        {_.indexOf(this.props.products, 3) !== -1 && <div className={style.group}>
          <h2>GoGuardian Fleet</h2>
          <Button onClick={this.fleetClick} block>
            Take me to my Fleet Dashboard
          </Button>
        </div>}

        {_.indexOf(this.props.products, 4) !== -1 && <div className={style.group}>
          <h2>GoGuardian Director</h2>
          <Button onClick={this.directorClick} block>
            Take me to my Director Dashboard
          </Button>
        </div>}
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  let products = [];
  if (state.enableProducts) {
    products = state.enableProducts.products;
  }
  return {
    products: products
  };
};
export default connect(mapStateToProps)(Finish);



/** WEBPACK FOOTER **
 ** ./src/app/components/gettingStarted/end/index.jsx
 **/